import { useCallback, useEffect } from 'react';
import { IUser } from '../models';
import { UsersApi } from '../../../api/usersApi';
import { endpoints } from 'endpoints.config';

export const useFetchUserDetails = (
  action: 'view' | 'update',
  id: number,
  setInitialState: React.Dispatch<React.SetStateAction<IUser | null>>,
  setError: React.Dispatch<React.SetStateAction<string>>
) => {
  const fetchUserDetails = useCallback(async () => {
    const url =
      action === 'view'
        ? endpoints.manageUsers.viewuser
        : endpoints.manageUsers.updateuser;
    const result = await UsersApi.getUserDetails(url, id);
    if (result.data) {
      const data = result.data;
      setInitialState(data);
    }

    if (result.error) {
      const error = result.error.message;
      setError(error);
    }
  }, []);

  useEffect(() => {
    fetchUserDetails();
  }, []);
};

export default useFetchUserDetails;
